// JS for side cart - 24032026 - V

const SIDE_CART_CONFIG = {
    autoOpenOnAdd: true
}

//Storing last added product for highlight
window.lastAddedVariantId = null; 

// Get Cart Data
async function fetchCart(){
    const res = await fetch('/cart.js');
    return await res.json();
}

function formatMoney(cents){
    return (cents/100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    });
}

function cartOverlay(){
    const container = document.querySelector('.side-cart-items');
    if(!container) return;

    let overlay = container.querySelector('.side-cart-loading-overlay');

    if(!overlay){
        overlay = document.createElement('div');
        overlay.className = 'side-cart-loading-overlay';
        overlay.innerHTML = '<span>Updating cart, please wait...</span>';
        container.appendChild(overlay);
    }
}

function renderCart(cart){
    const itemsContainer = document.querySelector('.side-cart-items');
    const subtotalEl = document.querySelector('.side-cart-footer .subtotal-section .cart-subtotal');
    const countEl = document.querySelector('.cart-count');
    const innerCountEl = document.querySelector('.sidecart-total-items');
    const triggerEl = document.getElementById('side-cart-trigger');

    if(!itemsContainer || !subtotalEl || !countEl) return;

    //Hide side cart trigger if cart quanity is zero - 16 07 2026 - V
    if(triggerEl){
        triggerEl.classList.toggle('sc-trigger-visible', cart.item_count > 0 );
    }

    //Outer Trigger count; Only add number if cart is not empty
    if(cart.item_count > 0){
        countEl.textContent = cart.item_count;
    }
    if(cart.item_count == 0){
        countEl.textContent = '';
    }
    //Inner Cart count
    innerCountEl.textContent =  cart.item_count + ' items';

    //Navbar cart count sync
    const headerCountEl = document.querySelector('[data-header-cart-count]');
    
    if(headerCountEl){
        // headerCountEl.textContent = cart.item_count;
        headerCountEl.style.opacity = 1;
        headerCountEl.setAttribute('data-header-cart-count', cart.item_count);
    }
    
    //Hide navbar cart count if quantity = 0 | Imitating default theme behavior
    if(cart.item_count == 0){
        headerCountEl.style.opacity = 0;
    }

    if(cart.item_count == undefined){
        headerCountEl.style.opacity = 0;
    }

    //Managing empty cart
    if(cart.item_count == 0){
        
        //Auto close empty side cart - 16 07 2026 - V
        const drawer = document.getElementById('side-cart');
        const overlay = document.getElementById('side-cart-overlay');

        if(drawer.classList.contains('open')){
            drawer.classList.remove('open');
            overlay?.classList.remove('open');

            const reamazewidget = document.getElementById('reamaze-widget'); 
            if(reamazewidget) reamazewidget.style.bottom = "90px";
        }

        itemsContainer.innerHTML = '<p> Your cart is empty</p>'
        subtotalEl.textContent = 'Subtotal: $0';
        return;
    }

    // Version 2
    itemsContainer.innerHTML = cart.items.map((item, index) => `
        <div class="side-cart-item" data-key="${item.key}" data-line="${index + 1}">
            <div class="img-box">
                <img src = "${item.image}" width="60"/>
            </div>
            <div class="item-info">
                <div class="sc-product-title"><a href="${item.url}">${item.product_title}</a></div>

                ${item.variant_title ? `
                <div class="sc-product-variation">Model: ${item.variant_title}</div>
                ` : ''}
                <div class="sc-product-final-price">${formatMoney(item.final_price)}</div>

                <div class="quantity-section">
                    <div class="qty-controls">
                        <button class="qty-minus">-</button>
                        <span class="qty"><span class="qty-value"> ${item.quantity}</span></span>
                        <button class="qty-plus">+</button>
                    </div>
                    <span class="item-total-price">Total: ${formatMoney(item.quantity * item.final_price)} </span>
                </div>
                <!--<button class="remove-item">Remove</button>-->
            </div>
        </div>
        `).join('');

    subtotalEl.textContent = 'Subtotal: ' + formatMoney(cart.total_price);

    if(window.lastAddedVariantId){
        const matchedItem = cart.items.find(
            item => item.variant_id == window.lastAddedVariantId
        );

        if(matchedItem){
            const el = document.querySelector(`[data-key="${matchedItem.key}"]`);

            if(el){
                el.classList.add('sc-highlight');

                setTimeout(() => {
                    el.classList.add('fade-out');

                    setTimeout(() => {
                        el.classList?.remove('sc-highlight', 'fade-out');
                    }, 1000);
                },3000);
            }
        }
        window.lastAddedVariantId = null;
    }
    cartOverlay();
}

// To show error on top of the cart | Not being used 
function showCartMessage(msg){
    const container = document.querySelector('#side-cart');

    let el = document.querySelector('.cart-error-msg');

    if(!el){
        el = document.createElement('div');
        el.className = 'cart-error-msg';
        container.prepend(el);
    }

    el.textContent = "ERROR: " + msg;

    //Slide in & out animation on error message
    requestAnimationFrame(() => {
        el.classList.remove('hide');
        el.classList.add('show');
    });

    // Auto hide after 3 seconds
    setTimeout(() => {
        el.classList.remove('show');
        el.classList.add('hide');

        setTimeout(() => {
            el?.remove();
        }, 300);
    }, 4000);
}

async function updateItemQuantity(key, quantity){

    let loadingTimer;
    let loadingShown = false;

    try{
        loadingTimer = setTimeout(() => {        
            document.body.classList.add('cart-loading');
            loadingShown = true; 
        }, 200);

        // Update cart | Update: Added error response handling - V 02 04 2026
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify({
                id: key,
                quantity: quantity
            })
        });

        if(!res.ok){
            const errorData = await res.json();
            throw errorData;
        }

        // console.log("SC: Cart fetched /cart/change.js - F1 ");

        // Fetch updated cart
        const updatedCart = await fetchCart();
        // console.log("SC: Cart fetched inside updateItemQuantity - F2 ");
        renderCart(updatedCart);

    } catch(e){
        if(e.description.includes("Only" && "item was added to your cart due to availability.")){
            console.warn("Limited avaialble quantity error.");    
        } else{
            console.error('Side Cart update failed:', e);
        }

        //Error handling on change.js cart update error
        showCartMessage(e.description.substring(0,75) || 'Unable to update quantity');

        const cart = await fetchCart();
        renderCart(cart);

    } finally{
        clearTimeout(loadingTimer);
        if(loadingShown){
            document.body.classList?.remove('cart-loading');
        }
    }
}

function moveReamazeWidgetUp(){
    const reamazewidget = document.getElementById('reamaze-widget'); 
    const reamazewidgetLabel = document.getElementById('reamaze-widget-label');

    if(reamazewidget) reamazewidget.style.bottom = "200px";
    if(reamazewidgetLabel) reamazewidgetLabel.style.display = "none";
}

function moveReamazeWidgetDown(){
    const reamazewidget = document.getElementById('reamaze-widget'); 
    const reamazewidgetLabel = document.getElementById('reamaze-widget-label');

    if(reamazewidget) reamazewidget.style.bottom = "90px";
    if(reamazewidgetLabel) reamazewidgetLabel.style.display = "none";
}

window.refreshSideCart = async function(){
    try{
        const cart = await fetchCart();
        // console.log("SC: Cart fetched inside refreshSideCart - F1 ");
        renderCart(cart);

        if(SIDE_CART_CONFIG.autoOpenOnAdd){
            const cartDrawer = document.getElementById('side-cart');
            const overlay = document.getElementById('side-cart-overlay');
            // const reamazewidget = document.getElementById('reamaze-widget'); 

            cartDrawer.classList.add('open');
            overlay.classList.add('open');

            // if(reamazewidget) reamazewidget.style.bottom = "200px";
            moveReamazeWidgetUp();
        }
    } catch(e){
        console.error('Side Cart refresh error:', e);
    }
};

document.addEventListener('DOMContentLoaded', function(){

    const cartDrawer = document.getElementById('side-cart');
    const overlay = document.getElementById('side-cart-overlay');
    const trigger = document.getElementById('side-cart-trigger');
    const closeBtn = document.getElementById('side-cart-close');

    function openCart(){
        // console.log("========== VARUN: openCart() called");
        cartDrawer.classList.add('open');
        overlay.classList.add('open');

        // const reamazewidget = document.getElementById('reamaze-widget'); 
        // if(reamazewidget) reamazewidget.style.bottom = "200px";
        moveReamazeWidgetUp();
    }

    function closeCart(){
        cartDrawer.classList?.remove('open');
        overlay.classList?.remove('open');
        // const reamazewidget = document.getElementById('reamaze-widget'); 
        // if(reamazewidget) reamazewidget.style.bottom = "90px";
        moveReamazeWidgetDown();
    }

    if(trigger){
        trigger.addEventListener('click', () => {
            cartDrawer.classList.contains('open') ? closeCart() : openCart();
        });
    }

    if(closeBtn){
        closeBtn.addEventListener('click', closeCart);
    }

    if(overlay){
        overlay.addEventListener('click', closeCart);
    }

    //For Quantity buttons
    document.addEventListener('click', function(e){
        const itemEl = e.target.closest('.side-cart-item');
        if(!itemEl) return;

        const key = itemEl.dataset.key;
        const qtyEl = itemEl.querySelector('.qty');
        const currentQty = parseInt(qtyEl.textContent.trim());
        const valEl = itemEl.querySelector('.qty-value');

        if(!key){
            console.warn('Sidecart: Invalid key item:', key);
            return;
        }

        if(e.target.classList.contains('qty-plus') || e.target.classList.contains('qty-minus')){
            if(valEl){
                valEl.classList.add('qty-animate');

                setTimeout(() => {
                    valEl.classList?.remove('qty-animate');
                }, 200);
            }
        }

        //For Optimistic/Instant update of Quantity value
        // const valEl = itemEl.querySelector('.qty-value');
        const totalEl = itemEl.querySelector('.item-total-price');

        let newQty = currentQty;

        if(e.target.classList.contains('qty-plus')){
            newQty = currentQty + 1;
        }

        if(e.target.classList.contains('qty-minus')){
            newQty = Math.max(0, currentQty-1);
        }
        
        //Optimistic update
        if(valEl){
            valEl.textContent = newQty;
        }

        if(totalEl){
            const priceText = itemEl.querySelector('.sc-product-final-price')?.textContent;
            const unitPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));

            if(unitPrice){
                totalEl.textContent = 'Total: ' + formatMoney(unitPrice * 100 * newQty);
            }
        }

        //For qty increment
        if(e.target.classList.contains('qty-plus')){
            updateItemQuantity(key, newQty);
        }

        //For qty decrement
        if(e.target.classList.contains('qty-minus')){
            // if(currentQty > 0){
                updateItemQuantity(key, newQty);
            // }
        }

        //For remove button - Commented as remove button is not added
        // if(e.target.classList.contains('remove-item')){
        //     updateItemQuantity(key,0);
        // }

        // console.log('Sidecart: Updating key:', key, 'newQty:', newQty);
    });

    //For bypassing cart redirection on Product page ATC & using Side cart instead
    document.addEventListener('submit', async function(e){
        const form = e.target;

        if(!form.matches('form[action*="/cart/add"]')) return;
        e.preventDefault();

        try{
            const formData = new FormData(form);

            await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });

            window.refreshSideCart();
        } catch(err){
            console.error('Sidecart: Product page ATC error:', err);
        }
    });

    (async function initCart() {
        try{
            const cart = await fetchCart();
            // console.log("SC: Cart fetched inside initCart - F1 ");
            renderCart(cart);
        } catch(e){
            console.error('Side Cart load error: ', e);
        }
    })();

    cartOverlay();

// Version 02
(function(){
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method,url){
        this.addEventListener('load', function(){
            try{
                if(typeof url === 'string' && url.includes('/cart/add')){
                    try{
                        const data = JSON.parse(this.responseText);

                        //Store last added variant
                        window.lastAddedVariantId = data.variant_id;
                    } catch(err){
                        console.warn('Sidecart: Variant capture failed: ', err);
                    }

                    setTimeout(() =>{
                        window.refreshSideCart();
                    }, 300);
                }
            } catch(e){
                console.warn('Sidecart: XHR hook error: ', e);
            }
        });
        return originalOpen.apply(this, arguments);
    };
})();

    //Handling BFCache issue on back press from checkout page in case of Buy now action
    let lastCartFetch = 0;

    window.addEventListener('pageshow', function(){
        const now = Date.now;

        //If last fetch was more than 2 seconds ago
        if(now - lastCartFetch > 2000){
            // console.log("Sidecart: Cart refresh on back/forward button press.")
            window.refreshSideCart();
            lastCartFetch = now;
        } else{
            // console.log("Sidecart: Cart NOT refresh on back/forward button press. Last fetch Time less than 2 seconds")
        }
    })

    // Fallback: For manual fresh cases; Runs when page regains focus | Conflicting with auto-open
    // window.addEventListener('focus', () => {
    //     window.refreshSideCart();
    // });
    
}) //DOMContentLoaded ends

